module.exports = __webpack_public_path__ + "static/media/wave.540aa83a.png";